/* eslint-env browser */
/* global fetch, FormData, mytheme_ajax_object */

/**
 * Handles AJAX-based pagination for blog listing.
 * Fetches filtered posts based on category and page number.
 * @param {number} paged - The page number to fetch (default is 1).
 */
function mytheme_ajaxPagination(paged = 1) {
    const postcategoryElement = document.getElementById('postcategory');
    const postcategory = postcategoryElement ? postcategoryElement.value : '';

    const data = new FormData();
    data.append('action', 'mytheme_ajaxsearch_filter');
    data.append('postcategory', postcategory);
    data.append('paged', paged);
    data.append('nonce', mytheme_ajax_object.nonce);

    const loadingIndicator = document.querySelector('.loading');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'block';
    }

    fetch(mytheme_ajax_object.ajax_url, {
        method: 'POST',
        body: data,
    })
        .then((response) => response.text())
        .then((html) => {
            const blogListing = document.querySelector('.blog-listing');
            if (blogListing) {
                blogListing.innerHTML = html;
            }
        })
        .finally(() => {
            if (loadingIndicator) {
                loadingIndicator.style.display = 'none';
            }
        });
}

/** Trigger AJAX pagination when the category dropdown changes */
document.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'postcategory') {
        mytheme_ajaxPagination();
    }
});

/** Handle pagination clicks */
document.addEventListener('click', function(e) {
    const target = e.target;
    const pageLink = target.closest('.pagination .page-numbers');
    if (pageLink) {
        e.preventDefault();
        const pageValue = pageLink.textContent.trim();
        const page = parseInt(pageValue, 10);
        if (!isNaN(page)) {
            mytheme_ajaxPagination(page);
        }
    }
});


jQuery(document).ready(function($) {

    Fancybox.bind('[data-fancybox=\"gallery\"]', {

        Image: {
            zoom: false,
            fit: 'contain',
        },
        fullscreen: false,

        Thumbs: {
            autoStart: true,
        },

    });

});

jQuery(document).ready(function() {
    jQuery('.cs-inner-mid').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,  // Enable dots navigation
        arrows: false,  // Disable arrow navigation
        centerMode: false,
        focusOnSelect: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    });
    // Function to trigger counter animation
    function triggerCounterAnimation($this, count, isPercentage) {
        // Animate from 0 to the target number
        jQuery({ countNum: 0 }).animate({ countNum: count }, {
            duration: 750,   // Animation duration (750ms)
            easing: 'swing',  // Easing function
            step: function() {
                const currentVal = Math.ceil(this.countNum).toLocaleString();  // Format the number
                if (isPercentage) {
                    $this.find('.value').text(currentVal + '%'); // Append percentage sign
                } else {
                    $this.find('.value').text(currentVal + '+'); // Append '+' sign for numbers
                }
            },
            complete: function() {
                const finalVal = count.toLocaleString();  // Ensure the final value is formatted
                if (isPercentage) {
                    $this.find('.value').text(finalVal + '%'); // Add percentage sign
                } else {
                    $this.find('.value').text(finalVal + '+'); // Add '+' sign
                }
            },
        });
    }

    // Intersection Observer to detect when the counter comes into the viewport
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const $this = jQuery(entry.target); // Get the target .cs-counter-item
                const valueText = $this.find('.value').text(); // Get the text value
                const isPercentage = valueText.includes('%'); // Check if it is a percentage
                const count = parseInt(valueText.replace('%', '').replace('+', '').replace(/,/g, '')); // Get the number

                // Trigger animation when the element is in view
                triggerCounterAnimation($this, count, isPercentage);

                // Stop observing this element after the animation is triggered
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });  // Trigger when 50% of the element is in the viewport

    // Observe all the counter items
    jQuery('.cs-counter-item').each(function() {
        observer.observe(this);
    });
});